import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import PostTable from '@cms/components/tables/post-table/post-table.vue';

@Component({
  name: 'bpc-post',
  components: {
    'bpc-post-table': PostTable,
  },
})
export default class Posts extends Vue {
  public filterConfigName = 'news-filters';
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
